// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__ixabK","track":"Toggle_track__wmtC1","trackChecked":"Toggle_trackChecked__zsOpl","dot":"Toggle_dot__YQYTt"};